import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

export const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 px-6 py-4 md:py-6">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Brand */}
        <motion.div 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col"
        >
          <h1 className="text-xl md:text-2xl font-serif tracking-wide text-foreground">
            {t('brand')}
          </h1>
          <span className="text-xs tracking-[0.2em] uppercase text-muted-foreground mt-0.5 hidden sm:block">
            {t('tagline')}
          </span>
        </motion.div>

        {/* Language Toggle */}
        <motion.button
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          onClick={toggleLanguage}
          className="group relative flex items-center gap-2 px-4 py-2 rounded-full border border-border hover:border-foreground/30 transition-colors duration-300"
        >
          <span 
            className={`text-sm tracking-wider transition-colors duration-300 ${
              language === 'en' ? 'text-foreground font-medium' : 'text-muted-foreground'
            }`}
          >
            EN
          </span>
          
          {/* Toggle indicator */}
          <div className="relative w-10 h-5 bg-secondary rounded-full overflow-hidden">
            <motion.div
              className="absolute top-0.5 w-4 h-4 bg-foreground rounded-full"
              animate={{ x: language === 'jp' ? 22 : 2 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            />
          </div>
          
          <span 
            className={`text-sm tracking-wider transition-colors duration-300 ${
              language === 'jp' ? 'text-foreground font-medium' : 'text-muted-foreground'
            }`}
          >
            JP
          </span>
        </motion.button>
      </div>
    </header>
  );
};
